import InternalStakeholderDefinition from "../model/InternalStakeholderDefinition";

export default class InternalStakeholderInteractionEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {InternalStakeholderDefinition} internalStakeholder 
     */
    constructor(type, internalStakeholder) {
        this.type = type;
        this.internalStakeholder = internalStakeholder;
    }
}

InternalStakeholderInteractionEvent.REQUEST_CONVERSATION = "InternalStakeholderInteractionEvent.REQUEST_CONVERSATION";